exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-[client]-[category]-[id]-tsx": () => import("./../../../src/pages/[client]/[category]/[id].tsx" /* webpackChunkName: "component---src-pages-[client]-[category]-[id]-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

